export { colorOverrides as colors } from "./colorOverrides";

export const fontSizes = {
  fontSize0: "10px",
  fontSize1: "12px",
  fontSize2: "13px",
  fontSize3: "14px",
  fontSize4: "16px",
  fontSize5: "18px",
  fontSize6: "20px",
  fontSize7: "24px",
  fontSize8: "28px",
  fontSize9: "32px",
  fontSize10: "40px",
  fontSize11: "52px",
  fontSize12: "68px",
  fontSize13: "88px",
};
export const lineHeights = {
  lineHeight0: 1.25,
  lineHeight1: 1.5,
};

export const fontWeights = {
  fontWeight0: 300,
  fontWeight1: 400,
  fontWeight2: 500,
  fontWeight3: 600,
};

export const fontFamily = {
  fontFamilySans:
    'Lexend, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: "monospace",
};

export const spacings = {
  space0: "4px",
  space1: "8px",
  space2: "12px",
  space3: "16px",
  space4: "20px",
  space5: "24px",
  space6: "32px",
  space7: "48px",
  space8: "80px",
  space9: "144px",
};

export const breakpoints = {
  xsmall: "599px",
  small: "1023px",
  medium: "1439px",
  large: "1919px",
  xlarge: "3840px",
};

export const borders = {
  radiusSmall: "4px",
  blueRegular2px: "2px solid rgba(31,131,219,1)",
  blackRegular1px: "1px solid rgba(5,5,5,1)",
  blackLight1px: "1px solid rgba(5,5,5,0.7)",
};
